window.TipoDocumento = Backbone.Model.extend({

});

window.TiposDocumento = Backbone.Collection.extend({
    model: TipoDocumento
});